const TmpPE018 = (page, section) => {
  const media = [];
  const eMentors = [];
  const modifiedPage = {
    ...page,
  };

  page.content.dialog_segments.forEach((segment, index) => {
    // loop through the initial prompts and add the video data to the segment
    segment.initial_prompts.forEach((ip, ipNum) => {
      let ipMedia = {
        id: page.id + "_d" + index + "_ip" + ipNum,
        page: page.id,
        author: "Team ACV/AAC",
        author_desc_en: "Team ACV/AAC",
        author_desc_tl: "N/A",
        cc_license: "N/A",
        description: "Phone call audio for " + page.label + ": dialog " + (index + 1) + " initial prompt " + (ipNum + 1),
        downloaded_date: new Date().toISOString(),
        published_date: new Date().toISOString(),
        media_url: "https://base-media-repo.web.app/" + page.label.slice(0, 2).toUpperCase() + "/audio/" + page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_ip" + ipNum + ".mp3",
        source_url: "Team ACV/AAC",
        src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_ip" + ipNum + ".mp3",
        title_en: "N/A",
        title_tl: "N/A",
        transcript: ip.text,
        type: "audio",
      };
      // add the media object to the media array
      media.push(ipMedia);
      // add the media object to the modified page
      modifiedPage.content.dialog_segments[index].initial_prompts[ipNum].media = {
        id: page.id + "_d" + index + "_ip" + ipNum,
        src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_ip" + ipNum + ".mp3",
      };
    });

    segment.initial_responses.forEach((ir, irNum) => {
      ir.feedbacks.forEach((feedback, fNum) => {
        let irMedia = {
          id: page.id + "_d" + index + "_ir" + irNum + "_f" + fNum,
          page: page.id,
          author: "Team ACV/AAC",
          author_desc_en: "Team ACV/AAC",
          author_desc_tl: "N/A",
          cc_license: "N/A",
          description: "Phone call audio for " + page.label + ": dialog " + (index + 1) + " initial response " + (irNum + 1) + " feedback " + (fNum + 1),
          downloaded_date: new Date().toISOString(),
          published_date: new Date().toISOString(),
          media_url: "https://base-media-repo.web.app/" + page.label.slice(0, 2).toUpperCase() + "/audio/" + page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_ir" + irNum + "_f" + fNum + ".mp3",
          source_url: "Team ACV/AAC",
          src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_ir" + irNum + "_f" + fNum + ".mp3",
          title_en: "N/A",
          title_tl: "N/A",
          transcript: feedback.text,
          type: "audio",
        };
        // add the media object to the media array
        media.push(irMedia);
        // add the media object to the modified page
        modifiedPage.content.dialog_segments[index].initial_responses[irNum].feedbacks[fNum].media = {
          id: page.id + "_d" + index + "_ir" + irNum + "_f" + fNum,
          src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_ir" + irNum + "_f" + fNum + ".mp3",
        };
        // correct 
      });
    });

    segment.self_correction_prompts.forEach((scp, scpNum) => {
      let scpMedia = {
        id: page.id + "_d" + index + "_scp" + scpNum,
        page: page.id,
        author: "Team ACV/AAC",
        author_desc_en: "Team ACV/AAC",
        author_desc_tl: "N/A",
        cc_license: "N/A",
        description: "Phone call audio for " + page.label + ": dialog " + (index + 1) + " self correction prompt " + (scpNum + 1),
        downloaded_date: new Date().toISOString(),
        published_date: new Date().toISOString(),
        media_url: "https://base-media-repo.web.app/" + page.label.slice(0, 2).toUpperCase() + "/audio/" + page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_scp" + scpNum + ".mp3",
        source_url: "Team ACV/AAC",
        src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_scp" + scpNum + ".mp3",
        title_en: "N/A",
        title_tl: "N/A",
        transcript: scp.text,
        type: "audio",
      };
      // add the media object to the media array
      media.push(scpMedia);
      // add the media object to the modified page
      modifiedPage.content.dialog_segments[index].self_correction_prompts[scpNum].media = {
        id: page.id + "_d" + index + "_scp" + scpNum,
        src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_scp" + scpNum + ".mp3",
      };
    });

    segment.self_correction_responses.forEach((scr, scrNum) => {
      scr.feedbacks.forEach((feedback, fNum) => {
        let scrMedia = {
          id: page.id + "_d" + index + "_scr" + scrNum + "_f" + fNum,
          page: page.id,
          author: "Team ACV/AAC",
          author_desc_en: "Team ACV/AAC",
          author_desc_tl: "N/A",
          cc_license: "N/A",
          description: "Phone call audio for " + page.label + ": dialog " + (index + 1) + " self correction response " + (scrNum + 1) + " feedback " + (fNum + 1),
          downloaded_date: new Date().toISOString(),
          published_date: new Date().toISOString(),
          media_url: "https://base-media-repo.web.app/" + page.label.slice(0, 2).toUpperCase() + "/audio/" + page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_scr" + scrNum + "_f" + fNum + ".mp3",
          source_url: "Team ACV/AAC",
          src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_scr" + scrNum + "_f" + fNum + ".mp3",
          title_en: "N/A",
          title_tl: "N/A",
          transcript: feedback.text,
          type: "audio",
        };
        // add the media object to the media array
        media.push(scrMedia);
        // add the media object to the modified page
        modifiedPage.content.dialog_segments[index].self_correction_responses[scrNum].feedbacks[fNum].media = {
          id: page.id + "_d" + index + "_scr" + scrNum + "_f" + fNum,
          src: page.label.toLowerCase().replaceAll("-", "_") + "_d" + index + "_scr" + scrNum + "_f" + fNum + ".mp3",
        };
      });
    });
  });

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id,
      };
      eMentors.push(eMentor);
    });
  } 

  // Extract metadata separately
  const metadata = {
    media: media,
    images: [],
    materials: [],
    eMentor: eMentors,
    focusPoints: [],
  };

  return { modifiedPage, metadata };
};

export default TmpPE018;